import { render, staticRenderFns } from "./SelectTheme.vue?vue&type=template&id=6bcd3cd4&scoped=true&"
import script from "./SelectTheme.vue?vue&type=script&lang=js&"
export * from "./SelectTheme.vue?vue&type=script&lang=js&"
import style0 from "./SelectTheme.vue?vue&type=style&index=0&id=6bcd3cd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcd3cd4",
  null
  
)

export default component.exports